"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgEditInverted = function SvgEditInverted(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M3.1 22.87L21.81 4.16l6 6L9.14 28.9 3.1 22.87zm-1.2 2.41l4.82 4.82L.05 32l1.85-6.72zM31 7l-1.35 1.38-6-6L25 1a3.2 3.2 0 014.53 0L31 2.49A3.2 3.2 0 0131 7z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgEditInverted);